import { http } from '@/core/api'
import type {
  AnalyticsEntityResponse,
  AnalyticsOverview,
  AnalyticsQuery,
  AnalyticsWorkersResponse,
} from '@/features/analytics/types/analytics-v1.types'

const BASE = '/analytics/v1'

async function get<T>(path: string, params: AnalyticsQuery): Promise<T> {
  const { data } = await http.get<{ data: T }>(`${BASE}/${path}`, { params })
  return data.data
}

export const analyticsV1Api = {
  overview: (params: AnalyticsQuery) => get<AnalyticsOverview>('overview', params),
  suppliers: (params: AnalyticsQuery) => get<AnalyticsEntityResponse>('suppliers', params),
  enterprises: (params: AnalyticsQuery) => get<AnalyticsEntityResponse>('enterprises', params),
  workers: (params: AnalyticsQuery) => get<AnalyticsWorkersResponse>('worker-profile', params),
}
